<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-notebook-2"></i>
                </div>
                <div class="header-text">
                    <h2>课程分类管理</h2>
                    <p>三级分类体系 · 层级结构维护</p>
                </div>
            </div>
            <div class="header-actions">
                <!-- 搜索区域 -->
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.accName" placeholder="搜索分类名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <!-- 分类类型筛选 -->
                <el-select v-if="level === 0" v-model="formDatas.accType" placeholder="分类类型" clearable size="medium" style="width: 120px; margin-right: 10px;" @change="partserch">
                    <el-option label="精选课程" :value="1"></el-option>
                    <el-option label="移动集采" :value="2"></el-option>
                    <el-option label="行业课程" :value="3"></el-option>
                </el-select>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn secondary" @click="importToFile">
                    <i class="el-icon-upload"></i>
                    批量导入
                </el-button>
                <el-button class="ai-btn secondary" @click="BoxOpen">
                    <i class="el-icon-plus"></i>
                    新增{{ level == 0 ? '一级分类' : level == 1 ? '二级分类' : '三级分类' }}
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Category Tabs & Data Table Card -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-menu"></i>
                        分类列表
                    </span>
                    <div class="card-actions">
                        <!-- <el-radio-group v-model="editableTabsValue" size="small" @change="tabsChange">
                            <el-radio-button
                                v-for="(item, index) in editableTabs"
                                :key="index"
                                :label="item.name"
                            >
                                {{ item.title }}
                            </el-radio-button>
                        </el-radio-group> -->
                        <el-tabs v-model="editableTabsValue" type="card" :closable="level != 0" @edit="handleTabsEdit"
                            @tab-click="tabsClick" style="margin: 0px auto 0;">
                            <el-tab-pane :key="index" v-for="(item, index) in editableTabs" :label="item.title"
                                :name="item.name" style="width: 91%;"></el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <div class="card-content">
                    <div class="table-wrapper">
                        <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="accId" :max-height="tableHeight-20"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                        <div v-show="tableData.length == 0" class="empty-data">
                            <i class="el-icon-inquiry"></i>
                            <p>暂无数据</p>
                        </div>
                    </div>
                    <div class="table-pagination">
                        <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                            :page-size="formDatas.pageSize"
                            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                            @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_form" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            :dialogTitle="'新增' + (level == 0 ? '一级分类' : level == 1 ? '二级分类' : '三级分类') + (theTitle ? ' @ ' + theTitle : '')"
            dialogWidth="600px" formSize="small" cancelText="关闭" confirmText="提交新增" @confirm="handleAddConfirm"
            @cancel="handleCancel" @update:dialogVisible="val => addDialogVisible = val" />
        <aj-form-edit ref="edit_form" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val"
            :dialogTitle="'编辑' + (level == 0 ? '一级分类' : level == 1 ? '二级分类' : '三级分类') + (theTitle ? ' @ ' + theTitle : '')"
            labelWidth="100px" @confirm="handleEditConfirm" @cancel="handleCancel" />
        <!-- 批量导入弹窗 -->
        <batch-import-dialog ref="importDialog" :visible.sync="importDialogVisible" title="批量导入课程分类" dialog-width="700px"
            upload-url="/ajCourseClass/uploadAjCourseClass"
            template-btn-text="下载导入模板" template-text="分类模板" accept-hint="xlsx、xls"
            :fail-columns="importFailColumns" fail-table-title="导入失败数据"
            template-url="https://equityappsub.aojuai.com/aicourse/excel/courseClassExcelIn.xlsx"
            :show-ai-extract-btn="false"
            :use-internal-pagination="true" :page-size="10" @upload-success="handleImportSuccess" />
    </div>
</template>

<script>

import { getAjCourseClassListOperation, getAjCourseClassList, addAjCourseClass, updateAjCourseClass, deleteAjCourseClass, uploadAjCourseClass } from "../../api/api";
// 导入批量导入组件
import BatchImportDialog from '@/components/ajForm/ajBatchImport.vue';
export default {
    name: "",
    components: {
        BatchImportDialog
    },
    data() {
        return {
            userPost: null,
            theTitle: '',
            addDialogVisible: false,
            editDialogVisible: false,
            // 批量导入相关
            importDialogVisible: false,
            importFailColumns: [
                { type: 'index', label: '序号', width: 60, align: 'center' },
                { label: '状态', prop: 'status', width: 90 },
                { label: '失败原因', prop: 'statusMsg', width: 150 },
                { label: '分类名称', prop: 'accName', width: 120 },
                { label: '分类类型', prop: 'accType', width: 100 },
                { label: '排序', prop: 'accOrder', width: 80 },
            ],
            // 精选课程一级分类下拉数据
            jxCourseOptions: [],
            // 当前一级分类的accType（用于三级分类判断）
            currentTopAccType: '',
            // formConfig: [
            //     [{ label: '分类名称', prop: 'accName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
            //     [{ label: '排序', prop: 'accOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
            // ],
            postForm: {

            },
            accParentId: 0,
            editableTabsValue: '0',
            editableTabs: [{
                title: '一级分类',
                name: '0',
            }],
            tabIndex: 0,

            level: 0,
            key: 'accId',
            dialog: false,
            edit: false,
            form: {
                accParentId: '',
                accName: '',
                accOrder: '',
                accType: '',
                accRelationTwoToOne: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHeight: 400,
            columns: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 60,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "accName",
                    key: "accName",
                    fixed: 'left',
                    title: "分类名称",
                    width: 150,
                    align: "center",
                },
                {
                    field: "accOrder",
                    key: "accOrder",
                    title: "排序",
                    align: "center",
                    width: 120,
                },
                {
                    field: "accType",
                    key: "accType",
                    title: "分类类型",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const typeMap = { 1: '精选课程', 2: '移动集采', 3: '行业课程' };
                        return row.accType ? typeMap[row.accType] || row.accType : '-';
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span class="operation-buttons">
                                {
                                    row.accLevel == 1
                                        ? <el-button
                                            size="mini"
                                            type="text"
                                            class="op-btn secondary"
                                            on-click={() => this.handleLevel(row)}
                                        >
                                            二级分类
                                        </el-button>
                                        : row.accLevel == 2
                                            ? <el-button
                                                size="mini"
                                                type="text"
                                                class="op-btn secondary"
                                                on-click={() => this.handleLevel(row)}
                                            >
                                                三级分类
                                            </el-button>
                                            : <span></span>
                                }
                                <el-button
                                    size="mini"
                                    type="text"
                                    class="op-btn"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    class="op-btn danger"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                accParentId: 0,
                accName: '',
                accType: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    computed: {
        formConfig() {
            // 依赖 form.accType、currentTopAccType、level 和 jxCourseOptions 以便在变化时重新计算
            const accType = this.form.accType || this.currentTopAccType;
            const level = this.level;
            // 引用 jxCourseOptions 确保依赖更新
            this.jxCourseOptions;
            console.log(accType, level);

            // 一级分类需要显示accType字段
            if (this.level === 0) {
                return [
                    [{ label: '分类名称', prop: 'accName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
                    [{ label: '分类类型', prop: 'accType', type: 'select', placeholder: '请选择分类类型', span: 24, required: true,
                        options: [
                            { label: '精选课程', value: 1 },
                            { label: '移动集采', value: 2 },
                            { label: '行业课程', value: 3 }
                        ],
                        optionLabelKey: 'label', optionValueKey: 'value'
                    }],
                    [{ label: '排序', prop: 'accOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
                ];
            }

            // 二级分类
            if (this.level === 1) {
                return [
                    [{ label: '分类名称', prop: 'accName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
                    [{ label: '排序', prop: 'accOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
                ];
            }

            // 三级分类
            if (this.level === 2) {
                // 三级分类且移动集采时，显示关联精选课程一级分类
                if (accType == 2) {
                    return [
                        [{ label: '分类名称', prop: 'accName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
                        [{ label: '关联精选课程', prop: 'accRelationTwoToOne', type: 'select', placeholder: '请选择关联的精选课程一级分类', span: 24, required: true,
                            options: this.jxCourseOptions,
                            optionLabelKey: 'label', optionValueKey: 'value'
                        }],
                        [{ label: '排序', prop: 'accOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
                    ];
                }
                return [
                    [{ label: '分类名称', prop: 'accName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
                    [{ label: '排序', prop: 'accOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
                ];
            }

            return [
                [{ label: '分类名称', prop: 'accName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
                [{ label: '排序', prop: 'accOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
            ];
        }
    },
    activated() {
        this.watchFlag = true;
        // 页面激活时更新表格高度
        this.$nextTick(() => {
            this.handleResize();
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHeight = val - 300 - val * 0.04;
                }
            });
        },
    },
    mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHeight = this.windheight - 300 - this.windheight * 0.04;
        this.userPost = window.localStorage.getItem('zhikeTong_userPost');
        this.getList();
        this.getPost('region')
        // 获取精选课程一级分类下拉数据
        this.getJxCourseOptions()
    },
    methods: {
        /**
         * 窗口大小变化时更新表格高度
         */
        handleResize() {
            this.$nextTick(() => {
                const bentoGrid = this.$el.querySelector('.bento-grid');
                if (bentoGrid) {
                    // bento-grid 容器高度 - bento-card padding - card-header - pagination - 额外偏移
                    const gridHeight = bentoGrid.offsetHeight;
                    const cardPadding = 40; // bento-card padding (20px * 2)
                    const cardHeaderHeight = this.$el.querySelector('.card-header')?.offsetHeight || 0;
                    const paginationHeight = this.$el.querySelector('.table-pagination')?.offsetHeight || 0;

                    this.tableHeight = Math.max(
                        gridHeight - cardPadding - cardHeaderHeight - paginationHeight - 20,
                        200
                    );
                }
            });
        },
        tabsChange(value) {
            this.editableTabsValue = value;
            this.tabIndex = parseInt(value);
            this.level = this.tabIndex;
            this.form.accParentId = this.editableTabs[this.tabIndex]?.accParentId || 0;
            this.accParentId = this.editableTabs[this.tabIndex]?.accParentId || 0;
            this.formDatas.accParentId = this.editableTabs[this.tabIndex]?.accParentId || 0;
            this.partserch();
        },
        resetSearch() {
            this.formDatas.accName = '';
            this.formDatas.accType = '';
            this.partserch();
        },
        handleCancel() {
            this.form = {
                accParentId: '',
                accName: '',
                accOrder: '',
                accType: '',
                accRelationTwoToOne: '',
            };
        },
        // 批量导入 - 打开弹窗
        importToFile() {
            this.importDialogVisible = true;
        },
        // 导入成功回调
        handleImportSuccess(data) {
            console.log('🎉 handleImportSuccess 被调用，导入成功:', data);
            console.log('🎉 成功数据条数:', data.successData ? data.successData.length : 0);
            // 刷新列表
            this.partserch();
            this.$message.success(`导入成功，共 ${data.successData ? data.successData.length : 0} 条数据`);
        },
        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该分类吗？',
                    type: 'danger'
                })
                // 确定逻辑
                deleteAjCourseClass({ accId: row.accId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error('删除失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            console.log('新增提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认新增分类吗？',
                    type: 'success'
                })
                // 确定逻辑
                const newData = JSON.parse(JSON.stringify(data));
                addAjCourseClass(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_form.cancelDiaLog();
                        this.form = {
                            accParentId: '',
                            accName: '',
                            accOrder: '',
                            accType: '',
                            accRelationTwoToOne: '',
                        };
                        console.log(this.form);
                        this.partserch();
                    } else {
                        this.$message.error('新增失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该分类吗？',
                    type: 'success'
                })
                // 确定逻辑
                const newData = JSON.parse(JSON.stringify(data));
                updateAjCourseClass(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_form.cancelDiaLog();
                        this.form = {
                            accParentId: '',
                            accName: '',
                            accOrder: '',
                            accType: '',
                            accRelationTwoToOne: '',
                        };
                        this.partserch();
                    } else {
                        this.$message.error('编辑失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        getPost(key) {
            const userpost = JSON.parse(localStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        tabsClick(e) {
            console.log(e);
            this.editableTabsValue = e.name;
            this.tabIndex = this.editableTabsValue;
            this.level = this.tabIndex * 1;
            this.form.accParentId = this.editableTabs[e.index * 1].accParentId || 0;
            this.accParentId = this.editableTabs[e.index * 1].accParentId || 0;
            this.formDatas.accParentId = this.editableTabs[e.index * 1].accParentId || 0;
            // 非一级分类时清空accType筛选
            if (this.level !== 0) {
                this.formDatas.accType = '';
            }

            // 切换到一级分类时，获取并保存当前一级分类的accType
            if (this.level === 0 && this.tableData.length > 0) {
                const topLevelItem = this.tableData.find(item => item.accLevel === 1);
                if (topLevelItem) {
                    this.currentTopAccType = topLevelItem.accType;
                }
            }

            this.partserch()
        },
        handleTabsEdit(targetName, action) {
            if (action === 'remove') {
                let tabs = this.editableTabs;
                let activeName = this.editableTabsValue;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                console.log('1', this.editableTabsValue);
                                activeName = nextTab.name;

                            }
                        }
                    });
                }

                this.editableTabsValue = activeName;
                const tabarr = this.editableTabs = tabs.filter(tab => tab.name !== targetName);
                console.log(this.editableTabs);
                this.tabIndex = tabarr[tabarr.length - 1].name;
                this.level = tabarr[tabarr.length - 1].name * 1;
                this.formDatas.accParentId = tabarr[tabarr.length - 1].accParentId || 0;
                this.partserch()
            }
        },
        handleLevel(row) {
            this.theTitle = row.accName
            if (row.accLevel == 1) {
                this.level = 1;
                console.log(this.level);
                this.tabIndex = this.editableTabsValue = 1 + '';
                // 进入二级分类时，保存一级分类的accType
                this.currentTopAccType = row.accType;
            } else {
                this.level = row.accLevel;
                console.log(this.level);
                this.tabIndex = this.editableTabsValue = row.accLevel + 1 + '';
            }
            this.formDatas.accParentId = this.accParentId = row.accId;
            // 进入二三级分类时清空accType筛选
            this.formDatas.accType = '';
            const s = {
                title: this.level == 1 ? '二级分类' : '三级分类',
                name: this.tabIndex,
                accParentId: row.accId
            }
            this.editableTabs.some((item, index) => {
                if (item.name === s.name) {

                    this.editableTabs.splice(index, 1, s)
                    console.log(this.editableTabs);
                    this.partserch();
                    return true
                } else if (index == this.editableTabs.length - 1 && item.name != s.name) {
                    this.editableTabs.push(s)
                    console.log(this.editableTabs);
                    this.partserch();
                }
            })


        },


        handleEdit(row) {
            if (this.level == 0 && this.userPost != 1) {
                this.$message({
                    type: "warning",
                    message: "您没有权限进行新增或者编辑一级分类",
                });
                return
            }
            const data = JSON.parse(JSON.stringify(row))
            this.editDialogVisible = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        BoxOpen() {
            console.log(this.leve, this.userPost);

            if (this.level == 0 && this.userPost != 1) {
                this.$message({
                    type: "warning",
                    message: "您没有权限进行新增或者编辑一级分类",
                });
                return
            }
            this.form.accParentId = this.accParentId;

            // 三级分类时，使用之前保存的一级分类accType
            if (this.level === 2) {
                this.form.accType = this.currentTopAccType;
            }

            this.addDialogVisible = true;
            console.log(this.form);
        },


        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.accId = row.accId
                    console.log(jsonObj);
                    updateAjCourseClass(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjCourseClassListOperation(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.authType = this.level;
            this.formDatas.currentPage = 1;
            getAjCourseClassListOperation(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjCourseClassListOperation(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        // 获取精选课程一级分类下拉数据
        getJxCourseOptions() {
            getAjCourseClassList({ accType: 1, accLevel: 1 }).then((res) => {
                if (res.data) {
                    this.jxCourseOptions = res.data.map(item => ({
                        label: item.accName,
                        value: item.accId
                    }));
                }
            });
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: calc(100vh - 60px);
    background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
    animation: fadeIn 0.5s ease-in-out;
    height: 100%;
    display: flex;
    flex-direction: column;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 24px 28px;
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(139, 92, 246, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-header:hover {
    box-shadow: 0 6px 28px rgba(139, 92, 246, 0.12), 0 3px 12px rgba(0, 0, 0, 0.06);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.header-icon:hover {
    transform: rotate(5deg) scale(1.05);
    box-shadow: 0 6px 16px rgba(139, 92, 246, 0.4);
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-search {
    flex: 1;
    max-width: 280px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
    color: white;
    box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
    position: relative;
    overflow: hidden;
}

.ai-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
}

.ai-btn:hover::before {
    left: 100%;
}

.ai-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(139, 92, 246, 0.45);
}

.ai-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.3);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 2px solid #e2e8f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #8b5cf6;
    color: #8b5cf6;
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.15);
}

/* AI Assistant Card */
.ai-grid {
    margin-bottom: 20px;
}

.ai-assistant-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
    border: 1px solid #a7f3d0;
    border-radius: 12px;
}

.ai-header {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ai-avatar {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-radius: 10px;
    color: white;
    font-size: 18px;
}

.ai-title {
    font-size: 14px;
    font-weight: 600;
    color: #065f46;
}

.ai-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.ai-hint-text {
    margin: 0;
    font-size: 13px;
    color: #047857;
}

.ai-hint-text .highlight {
    font-weight: 600;
    color: #059669;
}

.ai-actions {
    display: flex;
    gap: 8px;
}

.ai-action-btn {
    background: white;
    border: 1px solid #10b981;
    color: #10b981;
    border-radius: 8px;
}

.ai-action-btn:hover {
    background: #10b981;
    color: white;
}

/* Bento Grid */
.bento-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    flex: 1;
    min-height: 0;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #10b981;
}

/* Search Input */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #10b981;
    background: white;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

/* Table Styles */
.table-card {
    width: 100%;
}

.card-content {
    padding: 4px 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.table-wrapper {
    flex: 1;
    overflow: hidden;
    min-height: 0;
}

.table-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f1f5f9;
    flex-shrink: 0;
}

/* Empty State */
.empty-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    color: #94a3b8;
}

.empty-data i {
    font-size: 48px;
    margin-bottom: 12px;
}

.empty-data p {
    margin: 0;
    font-size: 14px;
}

/* Operation Buttons */
.operation-buttons {
    display: flex;
    gap: 4px;
    justify-content: center;
}

.op-btn {
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 6px;
    transition: all 0.2s;
}

.op-btn.secondary {
    color: #10b981;
    background: #ecfdf5;
}

.op-btn.secondary:hover {
    background: #10b981;
    color: white;
}

.op-btn.danger {
    color: #ef4444;
    background: #fef2f2;
}

.op-btn.danger:hover {
    background: #ef4444;
    color: white;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Tabs Style Override */
.card-actions ::v-deep .el-radio-button__inner {
    border: 1px solid #e2e8f0;
    border-radius: 8px !important;
    box-shadow: none !important;
    background: white;
    color: #64748b;
}

.card-actions ::v-deep .el-radio-button__original:checked+.el-radio-button__inner {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-color: #10b981;
    color: white;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }

    .ai-assistant-card {
        flex-direction: column;
        text-align: center;
    }

    .ai-actions {
        justify-content: center;
    }
}
</style>
